/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Sport_RunInputs */

const en_ui_sport_run = /** @type {(inputs: Ui_Sport_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run`)
};

const de_ui_sport_run = /** @type {(inputs: Ui_Sport_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lauf`)
};

/**
* | output |
* | --- |
* | "Run" |
*
* @param {Ui_Sport_RunInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_sport_run = /** @type {((inputs?: Ui_Sport_RunInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Sport_RunInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_sport_run(inputs)
	return de_ui_sport_run(inputs)
});